import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/creators")({
  head: () => ({
    meta: [
      { title: "Creator review — Admin" },
      { name: "description", content: "Approve, take live or reject creator applications and manage profiles." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: Outlet,
});
